// extracted by mini-css-extract-plugin
export default {"headerText":"ConfirmModal_headerText__TxfRF","buttonsGroup":"ConfirmModal_buttonsGroup__h5S8N"};